import { hotRank } from "@/mocks/chaqua";

const TAG_STYLE: Record<string, string> = {
  爆: "bg-coral-500 text-white",
  热: "bg-coral-100 text-coral-600",
  新: "bg-leaf-100 text-leaf-600",
};

const RANK_COLOR = (n: number) =>
  n === 1 ? "text-coral-500" : n === 2 ? "text-coral-400" : n === 3 ? "text-coral-300" : "text-stone-300";

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-cream-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-coral-500">Live Ranking</span>
            <h2 className="mt-2 text-2xl font-black text-stone-900 md:text-3xl">
              今日热榜 <span className="text-coral-500">TOP 10</span>
            </h2>
            <p className="mt-2 text-sm text-stone-500">今日热议持续滚动，热度实时更新，数字越高说明此刻聊的人越多。</p>
          </div>
          <div className="flex items-center gap-2 text-xs font-medium text-stone-400">
            <span className="flex items-center gap-1 rounded-full border border-cream-200 bg-white px-3 py-1.5 whitespace-nowrap">
              <i className="ri-time-line text-coral-500" aria-hidden="true"></i>每 10 分钟刷新
            </span>
            <span className="hidden items-center gap-1 rounded-full border border-cream-200 bg-white px-3 py-1.5 whitespace-nowrap sm:flex">
              <i className="ri-eye-line text-leaf-600" aria-hidden="true"></i>累计 12.6亿次浏览
            </span>
          </div>
        </div>

        <div className="grid gap-4 lg:grid-cols-2">
          {hotRank.map((item, idx) => (
            <article
              key={item.id}
              className="group flex items-center gap-4 rounded-2xl border border-cream-200 bg-white p-4 transition hover:-translate-y-0.5 hover:border-coral-200"
            >
              <span className={`font-display-num w-9 shrink-0 text-center text-2xl font-black ${RANK_COLOR(idx + 1)}`}>
                {String(idx + 1).padStart(2, "0")}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex items-start gap-2">
                  <span
                    className={`mt-0.5 inline-flex h-5 shrink-0 items-center rounded px-1.5 text-[11px] font-bold leading-5 ${TAG_STYLE[item.tag]}`}
                  >
                    {item.tag}
                  </span>
                  <h3 className="text-sm font-semibold leading-snug text-stone-800 transition group-hover:text-coral-600 md:text-[15px]">
                    {item.title}
                  </h3>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <div className="h-1.5 flex-1 rounded-full bg-cream-100">
                    <div
                      className="h-1.5 rounded-full transition-all"
                      style={{
                        width: `${item.heatNum}%`,
                        background:
                          idx < 3
                            ? "linear-gradient(90deg,#F6C4AC,#E45A2E)"
                            : "linear-gradient(90deg,#B7DCC6,#2E8F60)",
                      }}
                    ></div>
                  </div>
                  <span className="font-display-num shrink-0 text-xs text-stone-400">{item.heatText}</span>
                </div>
              </div>

              <div className="hidden shrink-0 flex-col items-end gap-2 md:flex">
                <span className="rounded-full bg-cream-100 px-2 py-0.5 text-[11px] font-medium text-stone-500">
                  {item.cat}
                </span>
                <span
                  className={`flex items-center gap-0.5 text-xs font-medium ${
                    item.trend === "up"
                      ? "text-coral-500"
                      : item.trend === "down"
                      ? "text-leaf-600"
                      : "text-stone-400"
                  }`}
                >
                  <i
                    className={
                      item.trend === "up"
                        ? "ri-arrow-up-line"
                        : item.trend === "down"
                        ? "ri-arrow-down-line"
                        : "ri-arrow-right-line"
                    }
                    aria-hidden="true"
                  ></i>
                  {item.trend === "up" ? "飙升" : item.trend === "down" ? "回落" : "持平"}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}